import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

export type DiscussionTarget = {
  entityType: string;
  entityId: string;
  title?: string;
} | null;

type Ctx = {
  override: DiscussionTarget;
  openDiscussion: (target: NonNullable<DiscussionTarget>) => void;
  clearDiscussionOverride: () => void;
};

const DiscussionContext = createContext<Ctx | null>(null);

export const DiscussionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [override, setOverride] = useState<DiscussionTarget>(null);

  const openDiscussion = useCallback((target: NonNullable<DiscussionTarget>) => setOverride(target), []);
  const clearDiscussionOverride = useCallback(() => setOverride(null), []);

  const value = useMemo(() => ({ override, openDiscussion, clearDiscussionOverride }), [override, openDiscussion, clearDiscussionOverride]);

  return <DiscussionContext.Provider value={value}>{children}</DiscussionContext.Provider>;
};

export function useDiscussionContext() {
  const ctx = useContext(DiscussionContext);
  if (!ctx) throw new Error('useDiscussionContext must be used within DiscussionProvider');
  return ctx;
}


